/**
 * Endorsement types and labels (P4.1). Store-free, so presentational
 * components (and their tests) do not pull in the Redux store.
 */

export type EndorsementEvidenceKind = 'assessment_result' | 'training_assignment';

export interface Endorsement {
  id: string;
  learnerUserId: string;
  learnerDisplayName?: string;
  endorserUserId: string;
  endorserDisplayName?: string;
  endorserRole: string;
  workspaceId: string;
  evidenceKind: EndorsementEvidenceKind;
  evidenceId: string;
  evidenceVersion: string;
  statement: string | null;
  visibleOnPortfolio: boolean;
  revokedAt: string | null;
  revokeReason: string | null;
  createdAt: string;
}

/** What a public portfolio shows of an endorsement the learner published. */
export interface PublicEndorsement {
  id: string;
  endorserDisplayName: string;
  evidenceKind: EndorsementEvidenceKind;
  endorsedAt: string;
}

export interface CreateEndorsementRequest {
  learnerUserId: string;
  evidenceKind: EndorsementEvidenceKind;
  evidenceId: string;
  statement?: string;
}

export const ENDORSEMENT_STATEMENT_MAX = 500;

export const EVIDENCE_KIND_LABELS: Record<EndorsementEvidenceKind, string> = {
  training_assignment: 'Training assignment',
  assessment_result: 'Assessment result',
};
